var map = {
	"./codeigniter.png": 2207,
	"./css.png": 9978,
	"./git.png": 7471,
	"./github.png": 5847,
	"./html.png": 4392,
	"./javascript.png": 6028,
	"./laravel.png": 5186,
	"./mysql.png": 487,
	"./php.png": 3194,
	"./wordpress.png": 5723
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9675;